var map = {
	"./breadcrumbs.module": 55270,
	"./breadcrumbs.module.ts": 55270,
	"./breadcrumbs.shared": 90087,
	"./breadcrumbs.shared.ts": 90087,
	"./component/breadcrumbs.component": 8201,
	"./component/breadcrumbs.component.ts": 8201,
	"./service/breadcrumbs.config": 13192,
	"./service/breadcrumbs.config.ts": 13192,
	"./service/breadcrumbs.resolver": 35179,
	"./service/breadcrumbs.resolver.ts": 35179,
	"./service/breadcrumbs.service": 90920,
	"./service/breadcrumbs.service.ts": 90920,
	"src/app/libs/breadcrumbs/breadcrumbs.module": 55270,
	"src/app/libs/breadcrumbs/breadcrumbs.module.ts": 55270,
	"src/app/libs/breadcrumbs/breadcrumbs.shared": 90087,
	"src/app/libs/breadcrumbs/breadcrumbs.shared.ts": 90087,
	"src/app/libs/breadcrumbs/component/breadcrumbs.component": 8201,
	"src/app/libs/breadcrumbs/component/breadcrumbs.component.ts": 8201,
	"src/app/libs/breadcrumbs/service/breadcrumbs.config": 13192,
	"src/app/libs/breadcrumbs/service/breadcrumbs.config.ts": 13192,
	"src/app/libs/breadcrumbs/service/breadcrumbs.resolver": 35179,
	"src/app/libs/breadcrumbs/service/breadcrumbs.resolver.ts": 35179,
	"src/app/libs/breadcrumbs/service/breadcrumbs.service": 90920,
	"src/app/libs/breadcrumbs/service/breadcrumbs.service.ts": 90920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5950;